import { useEffect, useState } from "react";

import controllerService from "../services/controller";
import { HTTPError } from "../../../src/types";

const useControllerState = () => {
    const [controllerState, setControllerState] = useState(true);
    const [loading, setLoading] = useState(false);
    const [ error, setError ] = useState({});
    useEffect(() => {
        (async() => {
            setLoading(true);
            try { 
                const state = await controllerService.getControllerState();
                setControllerState(state);
            }
            catch(e) {
                setError((e as HTTPError).response.data['error']);
            }
            finally {
                setLoading(false);
            }
        })();
    }, []);
    return { controllerState, setControllerState, loading, error };
};

export default useControllerState;